(function () {

    // Strict
    'use strict';

    // Controller
    angular.module('app').controller('toolbar.gps.controller', ['$rootScope', '$scope', '$filter', '$localStorage', '$timeout', '$uibModal', '$q', '$confirm', '$interval', 'toastr', 'map.factory', 'db.factory', 'api.factory', 'geometry.factory', 'log.factory', 'modal.service', 'sync.service', 'annotation.service', 'gps.service', function ($rootScope, $scope, $filter, $localStorage, $timeout, $uibModal, $q, $confirm, $interval, toastr, _map, _db, _api, _geometry, _log, _modal, _sync, _annotation, _gps) {

        var dialog = null;

        // State
        $scope.state = null;

        // Vector layer
        $scope.vector = null;

        // Layer
        $scope.layer = null;

        // Spec
        $scope.spec = null;

        // List of available specs based on layer
        $scope.specs = [];

        // Selected features
        $scope.selected = [];

        // Map singleclick
        $scope.singleclick = null;
        $scope.doubleclick = null;
    

        // Select event when select/modify
        $scope.selectedEvent = null;

        // Move to GPS position
        $scope.moveToGpsPosition_ = false;
        $scope.moveToSelectedPosition_ = false;

        // Interaction
        $scope.interactions = {
            'draw': null,
            'select': null,
            'snap': null
        };

        $scope.selectedPosition = null;

        // Buttons
        $scope.buttons = {
            'gpsDraw': false,
            'gpsPointInsert': false,
            'selectedPointInsert': false,
            'gpsDrawUndoLastPoint': false
        };

        // Available layers
        $scope.layers = [];

        // Select spec
        $scope.selectSpec = function ($event, spec) {
            if (!_.isNull($scope.selected) && $scope.selected.length > 0) {
                // Alleen wanneer spec gewijzigd wordt
                if ($scope.spec.SpecId != spec.SpecId) {

                    // Confirm
                    $confirm({ title: $filter('translate')('labels.changespectitle'), text: $filter('translate')('labels.changespecmessage') }).then(function () {

                        // Set spec
                        var f = _.first($scope.selected);
                        f.setProperties({
                            SpecId: spec.SpecId
                        });

                        // Add to DB
                        _geometry.updateIndexedDB(f).then(function () {

                            // Update dirty
                            $rootScope.$broadcast('application:tasks:dirty');

                            // Set spec
                            $scope.spec = spec;

                            // Reload geometry
                            // Reload from cache
                            $scope.$parent.reload().then(function () {
                            });
                        });
                    });
                }
            } else {
                // Set spec
                $scope.spec = spec;
            }
        };

        // Select layer
        $scope.selectLayer = function ($event, layer) {
            // Is layer editable?
            if (!layer.IsEditable) {
                $event.stopPropagation();
                $event.preventDefault();
                return false;
            }
            // Set layer
            $scope.layer = layer;

            // Vector layer
            $scope.vector = _map.layers.vector($scope.layer.CdoId);

            // Set buttons state
            $scope.setButtons();

            // Default select
            //$scope.select();
        };

        // Any geometry dirty update buttons
        $rootScope.$on('application:tasks:dirty', function () {
            $scope.setButtons();
        });

        // Set buttons state
        $scope.setButtons = function () {

            // Any dirty?
            _geometry.dirty().then(function (geometries) {
                // Commit
                $scope.buttons.commit = geometries.length > 0;
                // Dismiss only new added geometry
                $scope.buttons.dismiss = geometries.length > 0;
            });

            // Modify/Select
            if (!_.isNull($scope.layer)) {
                // Only enable 'modify' if any feature is available
                $scope.buttons.modify = _.filter($scope.vector.getSource().getFeatures(), function (feature) {
                    return feature.get('CdoId') == $scope.layer.CdoId;
                }).length > 0;
            }
        }

        $scope.gpsDraw = {
            active: false,
            interval : null,
            positions: [],
            trackFeature : null,
            trackFeatures : [],
            vector : null,
            potentialFeature: null,
            singleclick: null,
            featuresToMove: [],
            lastFeaturesMoved: [],
            potentialVector: null,
            lastCdo: null,
            lastSpec: null,

            positionsOnly: function () {
                var result = [];
                for (var i = 0; i < this.positions.length; i++) {
                    result.push(this.positions[i].position);
                }
                return result;
            },

            addPointToMoveClickHandler: function (event) {
                var tolerance = 150;
                var closestPoint = null;
                var mindist = Number.MAX_VALUE;
                var closestFeature = null;
                var i;
                for (i = 0; i < $scope.layers.length; i++) {
                    var layer = $scope.layers[i];
                    if (layer.TypeName == "PointStyle") {
                        var vectorLayer = _map.layers.vector(layer.CdoId);
                        if (vectorLayer != undefined) {
                            var features = vectorLayer.getSource().getFeatures();
                            for (var j = 0; j < features.length; j++) {
                                var feature = features[j];
                                if (feature == null) continue;
                                var coords = features[j].getGeometry().getCoordinates();
                                var featDist = new ol.geom.LineString([event.coordinate, coords]).getLength();
                                if (featDist < mindist) {
                                    mindist = featDist;
                                    closestPoint = coords;
                                    closestFeature = feature;
                                }
                            }
                        }
                    }
                }
                if (closestFeature != null) {
                    var pixel = _map.map.getPixelFromCoordinate(closestPoint);
                    if (distanceBetweenPixels(pixel, event.pixel) <= tolerance) {
                        var kvRemove = _.find($scope.gpsDraw.featuresToMove, function (o) { return o.featureToMove == closestFeature});
                        if (kvRemove != null) {
                            $scope.gpsDraw.vector.getSource().removeFeature(kvRemove.potential);
                            _.remove($scope.gpsDraw.featuresToMove, function (n) {
                                return n.featureToMove == closestFeature;
                            });
                        }
                        else {
                            var kv = {
                                featureToMove: closestFeature,
                                potential: $scope.gpsDraw.createFeature()
                            };
                            var style = new ol.style.Style({
                                stroke: new ol.style.Stroke({
                                    width: 1, color: 'rgba(128, 128, 128, 1)',
                                    lineDash: [3, 5]
                                })
                            });
                            kv.potential.setStyle(style);
                            $scope.gpsDraw.featuresToMove.push(kv);
                            $scope.gpsDraw.vector.getSource().addFeatures([kv.potential]);
                        }
                    }
                }
            },

            distance: function (pos1, pos2) {
                return new ol.geom.LineString([pos1, pos2]).getLength();
            },

            toggle: function (e) {
                if (this.active) {
                    this.stop(true);
                    //angular.element(e.target.parentElement.parentElement).removeClass('active');
                }
                else {
                    this.start();
                    //angular.element(e.target.parentElement.parentElement).addClass('active');
                }
            },

            start: function () {
                $scope.gpsDraw.vector = $scope.vector;

                // Start interval, every x-seconds check GPS position
                $scope.gpsDraw.interval = $interval($scope.gpsDraw.drawPotential, (50));
                this.active = true;
                $scope.buttons.gpsPointInsert = true;
                $scope.buttons.selectedPointInsert = true;
                $scope.gpsDraw.singleclick = _map.map.on('singleclick', $scope.gpsDraw.addPointToMoveClickHandler);
            },

            drawPotential: function () {
                var position = _.clone(_gps.position());

                // Skip if last position is the same as the current position
                if ($scope.gpsDraw.lastPosition == null || position == null || ($scope.gpsDraw.distance(position, $scope.gpsDraw.lastPosition) < $rootScope.settings.gpsTrackTolerance))
                    return;

                // LineString
                if ($scope.layer.TypeName == 'LineStyle' && $scope.gpsDraw.positions.length > 0) {
                    if ($scope.gpsDraw.potentialFeature == null) {
                        $scope.gpsDraw.potentialFeature = $scope.gpsDraw.createFeature();
                        var style = new ol.style.Style({
                            stroke: new ol.style.Stroke({
                                width: 2, color: 'rgba(0, 0, 0, 1)',
                                lineDash: [5, 5]
                            })
                        });
                        $scope.gpsDraw.potentialFeature.setStyle(style);
                        $scope.gpsDraw.vector.getSource().addFeatures([$scope.gpsDraw.potentialFeature]);
                    }
                    $scope.gpsDraw.potentialFeature.setGeometry(new ol.geom.LineString([$scope.gpsDraw.lastPosition, position]));

                    for (var i = 0; i < $scope.gpsDraw.featuresToMove.length; i++) {
                        $scope.gpsDraw.featuresToMove[i].potential.setGeometry(new ol.geom.LineString([$scope.gpsDraw.featuresToMove[i].featureToMove.getGeometry().getCoordinates(), position]));
                    }
                }
            },

            undoLastPoint: function () {
                if (this.positions.length == 0) return;
                var positionHistory = this.positions.pop();
                for (var i = 0; i < positionHistory.featuresMoved.length; i++) {
                    var f = positionHistory.featuresMoved[i].feature;
                    f.setGeometry(positionHistory.featuresMoved[i].oldCoord);
                }
                if (this.trackFeature != null && this.trackFeature.getGeometry().getType() == 'LineString') {
                    if (this.positions.length < 2) {
                        this.vector.getSource().removeFeature(this.trackFeature);
                        this.trackFeature = null;
                        this.vector.getSource().refresh();
                    }
                    else {
                        this.trackFeature.setGeometry(new ol.geom.LineString($scope.gpsDraw.positionsOnly()));
                        this.vector.getSource().refresh();
                    }
                }
                if (this.positions.length == 0) {
                    $scope.buttons.gpsDrawUndoLastPoint = false;
                    this.lastPosition = null;
                    this.removePotential();
                }
                else {
                    this.lastPosition = this.positions[this.positions.length - 1].position;
                    this.drawPotential();
                }
            },

            removePotential: function () {
                if (this.potentialFeature != null) {
                    this.vector.getSource().removeFeature(this.potentialFeature);
                    this.potentialFeature = null;
                }
                while ($scope.gpsDraw.featuresToMove.length > 0) {
                    var kv = $scope.gpsDraw.featuresToMove.pop();
                    this.vector.getSource().removeFeature(kv.potential);
                }
                this.vector.getSource().refresh();
            },

            insertGPSPoint: function () {
                var position = null;
                if ($rootScope.settings.maximumGPSAccuracy > 0 && _gps.accuracy() > $rootScope.settings.maximumGPSAccuracy) {
                    var defer = $q.defer();
                    var abortDialog = _modal.alert({ text: $filter('translate')('messages.gpswaitingaccuracy') + " " + $rootScope.settings.maximumGPSAccuracy, ok: $filter('translate')('labels.abort') });
                    abortDialog.result.then(function () {
                        defer.reject(null);
                    });

                    var listener = $rootScope.$on('application:gps:accuracyDistance', function ($event, arg) {
                        if (arg <= $rootScope.settings.maximumGPSAccuracy) {
                            defer.resolve(arg);
                            listener();
                        }
                    });

                    defer.promise.then(function () {
                        abortDialog.dismiss();
                        position = _.clone(_gps.position());
                        $scope.gpsDraw.insertPoint(position, true);
                        if ($rootScope.settings.moveSelectedPosition) {
                            _gps.setSelectedPosition(position);
                        }
                    }, function () {});
                }
                else {
                    position = _.clone(_gps.position());
                    $scope.gpsDraw.insertPoint(position, true);
                    if ($rootScope.settings.moveSelectedPosition) {
                        _gps.setSelectedPosition(position);
                    }
                }
            },

            insertSelectedPoint: function () {
                $scope.gpsDraw.insertPoint(_gps.getSelectedPosition(), false);
            },

            newSegment: function () {
                if (!this.active) return;
                if (this.positions.length < 2) return;
                var changePoint = this.lastPosition;
                this.stop(true);
                this.start();
                this.insertPoint(changePoint, false);
            },

            insertPoint: function (point, moveFeatures) {
                if (_.isNull(point)) return;
                // Current GPS position
                var position = point;

                // Last position
                $scope.gpsDraw.lastPosition = position;

                var positionHistory = {
                    position: position,
                    featuresMoved: []
                };

                // Set last position
                $scope.gpsDraw.positions.push(positionHistory);

                // Point
                if ($scope.layer.TypeName == 'PointStyle') {
                    $scope.gpsDraw.trackFeature = createFeature();
                    $scope.gpsDraw.trackFeature.setGeometry(new ol.geom.Point(position));
                    $scope.gpsDraw.trackFeatures.push(this.trackFeature);
                    $scope.gpsDraw.vector.getSource().addFeatures([this.trackFeature]);
                }

                // LineString
                if ($scope.layer.TypeName == 'LineStyle' && $scope.gpsDraw.positions.length > 1) {
                    if ($scope.gpsDraw.trackFeature == null) {
                        $scope.gpsDraw.trackFeature = $scope.gpsDraw.createFeature();
                        $scope.gpsDraw.trackFeatures.push($scope.gpsDraw.trackFeature);
                        $scope.gpsDraw.vector.getSource().addFeatures([$scope.gpsDraw.trackFeature]);
                    }
                    else if (this.lastCdo != null && this.lastCdo != $scope.layer.CdoId || this.lastSpec != null && this.lastSpec != $scope.spec) {
                        this.newSegment();
                    }
                    $scope.gpsDraw.trackFeature.setGeometry(new ol.geom.LineString($scope.gpsDraw.positionsOnly()));
                    this.lastCdo = $scope.layer.CdoId;
                    this.lastSpec = $scope.spec;
                }

                if (moveFeatures) {
                    $scope.gpsDraw.lastFeaturesMoved = [];
                    for (var i = 0; i < $scope.gpsDraw.featuresToMove.length; i++) {
                        var kv = {
                            feature: $scope.gpsDraw.featuresToMove[i].featureToMove,
                            oldCoord: $scope.gpsDraw.featuresToMove[i].featureToMove.getGeometry()
                        };
                        positionHistory.featuresMoved.push(kv);
                        kv.feature.setGeometry(new ol.geom.Point(position));

                    }
                }
                $scope.buttons.gpsDrawUndoLastPoint = true;
                this.removePotential();
            },

            stop: function (save) {
                $scope.buttons.gpsPointInsert = false;
                $scope.buttons.selectedPointInsert = false;
                $scope.buttons.gpsDrawUndoLastPoint = false;

                if (!_.isNull($scope.gpsDraw.interval))
                    $interval.cancel($scope.gpsDraw.interval);

                if (save) {
                    // Save each feature
                    _.each($scope.gpsDraw.trackFeatures, function (feature) {
                        _geometry.insertIndexedDB(feature).then(function () {
                            // Update dirty
                            $rootScope.$broadcast('application:tasks:dirty');
                        });
                    });
                } else {
                    // Remove features from vector layer                    
                    _.each($scope.gpsDraw.trackFeatures, function (feature) {
                        $scope.gpsDraw.vector.getSource().removeFeature(feature);
                    });
                }

                if ($scope.gpsDraw.singleclick != null) {
                    ol.Observable.unByKey($scope.gpsDraw.singleclick);
                    $scope.gpsDraw.singleclick == null;
                }

                this.removePotential();
                // Clear parameters
                $scope.gpsDraw.trackFeatures = [];
                $scope.gpsDraw.trackFeature = null;
                $scope.gpsDraw.positions = [];
                $scope.gpsDraw.lastPosition = null;
                $scope.gpsDraw.interval = null;
                $scope.gpsDraw.active = false;
                $scope.gpsDraw.featuresToMove = [];
                $scope.gpsDraw.lastCdo = null;
                $scope.gpsDraw.lastSpec = null;
            },

            createFeature: function () {

                var feature = new ol.Feature();

                var projectHandle = 0;
                // Project from task
                if ($localStorage.settings.defaultProjectFromTask !== undefined && $localStorage.settings.defaultProjectFromTask == true && $rootScope.selectedTask !== undefined && $rootScope.selectedTask != null) {
                    projectHandle = $rootScope.selectedTask.ProjectHandle;
                } else {
                    // Selected project
                    if ($localStorage.defaultProject !== undefined && $localStorage.defaultProject != null) {
                        projectHandle = $localStorage.defaultProject.Handle;
                    } else {
                        // 'DefaultProjectHandle'
                        if ($rootScope.settings.defaultProjectHandle !== undefined && $rootScope.settings.defaultProjectHandle != null) {
                            projectHandle = $rootScope.settings.defaultProjectHandle;
                        }
                    }
                }

                // Set custom properties
                feature.setProperties({
                    layer: $scope.layer,
                    CdoId: $scope.layer.CdoId,
                    SpecId: $scope.spec,
                    ProjectHandle: projectHandle,
                    Handle: -1,
                    GpsTrack: true
                });

                return feature;
            }
        };

        $scope.getClosestCoordinateClickHandler = function (event) {
            var tolerance = 150;
            var closestPoint = null;
            var mindist = Number.MAX_VALUE;
            var i;
            for (i = 0; i < $scope.layers.length; i++) {
                var layer = $scope.layers[i];
                var vectorLayer = _map.layers.vector(layer.CdoId);
                if (vectorLayer != undefined) {
                    var features = vectorLayer.getSource().getFeatures();
                    for (var j = 0; j < features.length; j++) {
                        var feature = features[j];
                        var geom = feature.getGeometry();
                        if (geom == null) continue;
                        var coords = [];
                        if (geom.getType() == 'Point') {
                            coords.push(geom.getCoordinates());
                        }
                        else {
                            coords = geom.getCoordinates();
                        }
                        for (var k = 0; k < coords.length; k++) {
                            var featDist = new ol.geom.LineString([event.coordinate, coords[k]]).getLength();
                            if (featDist < mindist) {
                                mindist = featDist;
                                closestPoint = coords[k];
                            }
                        }
                    }

                }
            }
            if (closestPoint != null) {
                var pixel = _map.map.getPixelFromCoordinate(closestPoint);
                if (distanceBetweenPixels(pixel, event.pixel) <= tolerance) {
                    _gps.setSelectedPosition(closestPoint);
                }
            }
        };
        $scope.doubleclick = _map.map.on('dblclick', $scope.getClosestCoordinateClickHandler);

        //// Watch 'moveToGps'
        //$scope.$watch(function () { return $scope.moveToGpsPosition_; }, function (newValue, oldValue) {

        //    var position = _gps.position();
        //    var result = $scope.moveToPosition(position);
        //    if (result) {
        //        $scope.moveToGpsPosition_ = false;
        //        if ($rootScope.settings.moveSelectedPosition) {
        //            _gps.selectedPosition = position;
        //        }
        //    }

        //});

        //// Watch 'moveToSelected'
        //$scope.$watch(function () { return $scope.moveToGpsPosition_; }, function (newValue, oldValue) {
        //    var position = _gps.selectedPosition;
        //    var result = $scope.moveToPosition(position);
        //    if (result)
        //        $scope.moveToSelectedPosition_ = false;

        //});
        
        // Stop interactions
        $scope.stop = function () {
            if (!_.isNull($scope.interactions)) {
                // Select interaction
                if (!_.isNull($scope.interactions.select)) {
                    // Clear selected features
                    $scope.interactions.select.getFeatures().clear();
                    // Clear selected
                    $scope.selected = [];
                }

                // Remove interaction
                _map.map.removeInteraction($scope.interactions.draw);
                _map.map.removeInteraction($scope.interactions.select);
                _map.map.removeInteraction($scope.interactions.modify);
                _map.map.removeInteraction($scope.interactions.snap);


                // Remove interaction
                $scope.interactions.draw = null;
                $scope.interactions.select = null;
                $scope.interactions.modify = null;
                $scope.interactions.snap = null;
            }
            // Remove click
            if (!_.isNull($scope.singleclick)) {
                //_map.map.unByKey($scope.singleclick);
                ol.Observable.unByKey($scope.singleclick);
            }
            $scope.singleclick = null;

            if (!_.isNull($scope.doubleclick)) {
                ol.Observable.unByKey($scope.doubleclick);
            }
            $scope.doubleclick = null;

            _gps.setSelectedPosition(null);

            // Clear state
            $scope.state = null;
        };


        // Clear features drawn for newTask
        $scope.clearFeaturesForNewTask = function () {
            // Remove features
            _.each($scope.vector.getSource().getFeatures(), function (feature) {
                if (!_.isUndefined(feature.get('taskId')) && !_.isNull(feature.get('taskId')))
                    $scope.vector.getSource().removeFeature(feature);
            });
        }

        // Watch selected project.
        $scope.$watch(function () { return $localStorage.defaultProject; }, function (newValue, oldValue) {
            // Stop draw
            if ($scope.state == 'draw') {
                // Stop interactions
                $scope.stop();
                // Enable select
                $scope.select();
                return;
            }
        });

        // Watch state
        $scope.$watch(function () { return $scope.state; }, function (newValue, oldValue) {
            // Move to GPS allowed            
            $scope.buttons.moveToGps = ($scope.state == 'draw' && !_.isUndefined(_gps.position()) && !_.isNull(_gps.position()));
            $scope.buttons.moveToSelectedPosition = ($scope.state == 'draw' && !_.isUndefined(_gps.selectedPosition) && !_.isNull(_gps.selectedPosition));
        });

        $scope.$watch(function () { return _gps.selectedPosition; }, function (newValue, oldValue) {
            $scope.buttons.moveToSelectedPosition = ($scope.state == 'draw' && !_.isUndefined(_gps.selectedPosition) && !_.isNull(_gps.selectedPosition));
        });

        // Watch selected task
        $scope.$watch(function () { return $rootScope.selectedTask; }, function (newValue, oldValue) {
            if ($scope.state == 'draw' && ($rootScope.selectedTask === undefined || $rootScope.selectedTask == null) && ($localStorage.defaultProject === undefined || $localStorage.defaultProject == null)) {
                toastr.warning($filter('translate')('labels.usingdefaultprojecthandlenoproject'));
            }
        });

        // Watch MapModus
        $scope.$watch(function () { return $rootScope.mapMode; }, function (newValue, oldValue) {
            // Enable draw
            if ($rootScope.mapMode.Value == 'gpsmode') {
                // Buttons status
                $scope.setButtons();
                // Select
                if (!_.isNull($scope.layer))
                    $scope.select();
            }
        }, true);

        // Watch selected
        $scope.$watch(function () { return $scope.selected; }, function (newValue, oldValue) {
            // Delete allowed
            $scope.buttons.delete = $scope.selected.length > 0 && $scope.selected[0].get('Handle') == '-1';

            // Annotation dialog allowed   
            var useAnnotationDialog = false;
            if (!_.isNull($scope.selected) && $scope.selected.length > 0) {
                // Feature
                var f = _.first($scope.selected);

                if (f.get('Dirty'))
                    useAnnotationDialog = true;
                else {
                    useAnnotationDialog = $rootScope.applicationOnline;
                }

                // Set spec value if found
                var specId = f.get('SpecId');                
                if (!_.isUndefined(specId) && !_.isNull(specId)) {
                    var spec = _.find($scope.specs, { SpecId: specId });
                    if (!_.isUndefined(spec)) {
                        $scope.spec = spec;
                    }
                }
            }
            $scope.buttons.annotation = useAnnotationDialog && !_.isNull($scope.layer) && !_.isNull($scope.layer.DisplayFields) && $scope.layer.DisplayFields.length > 0 && !_.isNull($scope.selected) && $scope.selected.length > 0;

            // Move to GPS allowed
            if ($scope.interactions.select != null && !_.isUndefined(_gps.position()) && !_.isNull(_gps.position()))
                $scope.buttons.moveToGps = $scope.selected.length > 0;
            // Move to selected allowed
            if ($scope.interactions.select != null && !_.isUndefined(_gps.selectedPosition) && !_.isNull(_gps.selectedPosition))
                $scope.buttons.moveToSelectedPosition = $scope.selected.length > 0;
        });

        // Watch localStorage.cdotypes
        $scope.$watch(function () { return $localStorage.cdotypes; }, function (newValue, oldValue) {
            $scope.layers = _.filter($localStorage.map.layers, function (layer) {
                return !_.isUndefined(_.find($localStorage.cdotypes, { 'CdoId': layer.CdoId, 'Visible': true }));
            });
        }, true);

        // Watch layer, select Specs
        $scope.$watch(function () { return $scope.layer; }, function (newValue, oldValue) {
            $scope.spec = null;
            $scope.specs = [];

            // GpsTrack button

            if (!_.isNull($scope.layer)) {
                // Specs
                $scope.specs = _.filter($localStorage.specs, { CdoId: $scope.layer.CdoId });
                
                // First spec
                if ($scope.specs.length > 0) {
                    $scope.specs = _.sortBy($scope.specs, [function (o) { return o.Value; }]);
                    $scope.spec = _.first($scope.specs);
                }
            }
            $scope.buttons.gpsDraw = ($scope.layer != null && $scope.spec != null);
        });

        $scope.$watch(function () { return $scope.spec; }, function (newValue, oldValue) {
            if ($scope.gpsDraw.active) {
                $scope.gpsDraw.newSegment();
            }
            $scope.buttons.gpsDraw = ($scope.layer != null && $scope.spec != null);
        });

        // Watch 'online/offline'
        $scope.$watch(function () { return $rootScope.applicationOnline; }, function (newValue, oldValue) {
            // Annotation dialog allowed   
            var useAnnotationDialog = false;
            if (!_.isNull($scope.selected) && $scope.selected.length > 0) {
                if (_.first($scope.selected).get('Dirty'))
                    useAnnotationDialog = true;
                else {
                    useAnnotationDialog = $rootScope.applicationOnline;
                }
            }
            // Annotation allowed
            $scope.buttons.annotation = useAnnotationDialog && !_.isNull($scope.layer) && !_.isNull($scope.layer.DisplayFields) && $scope.layer.DisplayFields.length > 0 && !_.isNull($scope.selected) && $scope.selected.length > 0;
        });

        // Draw stop
        $rootScope.$on('application:gpsdraw:stop', function ($event, args) {
            // Enable toolbar
            $scope.$parent.page.disabled = false;
            // Clear features
            $scope.clearFeaturesForNewTask();
            // Clear layer
            $scope.layer = null;
            // Stop interaction
            $scope.stop();
        });

        // Draw start; Select layer
        $rootScope.$on('application:draw:start:selectlayer', function ($event, args) {
            // Select layer
            $scope.selectLayer(null, args.layer);
            // Stop interaction
            $scope.stop();
            // Start interaction
            $scope.draw();
        });

        // Data committed
        $rootScope.$on('application:data:synced', function () {
            // Check buttons
            $scope.setButtons();
            // Stop interactions
            $scope.stop();
            // Enable draw
            if ($rootScope.mapMode.Value == "drawmode") {
                // Buttons status
                $scope.setButtons();
                // Select
                if (!_.isNull($scope.layer))
                    $scope.select();
            }
        });

        // On reload data
        $rootScope.$on('application:map:load', function () {
            // Check buttons
            $scope.setButtons();
            // Stop interactions
            $scope.stop();
            // Select
            if (!_.isNull($scope.layer))
                $scope.select();
        });

        // On destroy panel
        $scope.$on('$destroy', function () {
            // Destroy events
            $scope.stop();
        });
    }]);

}());